import styled from "styled-components";

export const ToolbarContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;
